import React from 'react';
import PlayerTable from '../common/PlayerTable';

const COLS = [
  { key: 'rank', label: '#', width: 'w-8' },
  { key: 'player', label: 'Player' },
  { key: 'team', label: 'Team', muted: true },
  { key: 'appearances', label: 'Apps', align: 'right', width: 'w-10', bold: true },
  { key: 'goals', label: 'G', align: 'right', width: 'w-10' },
];

export default function Appearances({ appearances = [], ...rest }) {
  return (
    <PlayerTable
      {...rest}
      subtitle="Appearances"
      rows={appearances}
      columns={COLS}
      emptyMessage="No appearance data for this competition."
    />
  );
}
